import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {ErrorMessage} from 'shells/form/error-message';

import {ReduxFormCheckbox} from '../fields/redux-form-checkbox';

import styles from './fields-basic-info.module.css';

type BasicInfoFields = {
    hasRelated: {
        [fieldName: string]: FieldProps;
        meta: FieldProps['meta'];
    };
};

export const FieldsBasicInfo = (fields: BasicInfoFields) => {
    const {hasRelated} = fields;
    const {name, emailAddress, phone} = hasRelated;

    const showError = Boolean(hasRelated.meta.touched && hasRelated.meta.error);

    return (
        <div className={styles['fields-basic-info']}>
            <ReduxFormCheckbox {...name} hasError={showError} label='A person’s name' />
            <ReduxFormCheckbox {...emailAddress} hasError={showError} label='An email address' />
            <ReduxFormCheckbox {...phone} hasError={showError} label='A phone number' />
            {showError ? <ErrorMessage>{hasRelated.meta.error || ''}</ErrorMessage> : null}
        </div>
    );
};
